$( document ).ready(function() {
    $('.menu-drawer__submenu-item--has-child').on('click',function(){
        $(this).next().slideToggle("slow");
        $(this).toggleClass("c-show");
    });

    $('.menu-drawer__close--button').click(function(){
        $('body').removeClass('overflow-hidden-tablet');
    })
});



var announcementHeight = '-'+this.document.getElementById('shopify-section-announcement-bar').offsetHeight+'px';
var menuDrawer = this.document.getElementById('menu-drawer');
menuDrawer.style.top = announcementHeight;

document.documentElement.style.setProperty("--announcement-bar-height", announcementHeight);

window.addEventListener('resize', function(event) {
    var announcementHeight = '-'+this.document.getElementById('shopify-section-announcement-bar').offsetHeight+'px';

    var menuDrawer = this.document.getElementById('menu-drawer');
    menuDrawer.style.top = announcementHeight;

    document.documentElement.style.setProperty("--announcement-bar-height", announcementHeight);
}, true);